/// <amd-module name="Wit/Common/HotKeyEventService/IHotKeyEventService" />
import { IVssObservableService, Services, VssObservableService } from "VSS/Platform/Context";

export interface IHotKeyEventData {
    workItemId?: number | undefined | null;
    projectName?: string | undefined | null;

    teamId?: string;
    backlog?: string;
    iterationId?: string;
    row?: number;

    direction?: Direction;
}

export enum Direction {
    Up = 1,
    Down,
    Left,
    Right
}

export enum IHotKeyEventType {
    WorkItemChangeTitle = "WorkItemChangeTitle",
    WorkItemToggleEmptyFields = "WorkItemToggleEmptyFields",
    FilterToggled = "FilterToggled",
    WorkItemDelete = "WorkItemDelete",
    WorkItemCopy = "WorkItemCopy",
    NewWorkItem = "NewWorkItem",
    CollapseAllTeamRows = "CollapseAllTeamRows",
    ExpandAllTeamRows = "ExpandAllTeamRows",
    PanTimeline  = "PanTimeline",
    MoveWorkItem = "MoveWorkItem"
}

export type IHotKeyEvent = keyof typeof IHotKeyEventType;

export interface IHotKeyEventService extends IVssObservableService<IHotKeyEventData, IHotKeyEvent> {
    fireEvent(eventData: IHotKeyEventData, eventType: IHotKeyEvent): void;
}

class HotKeyEventService extends VssObservableService<IHotKeyEventData, IHotKeyEvent> implements IHotKeyEventService {
    public fireEvent(eventData: IHotKeyEventData, eventType: IHotKeyEvent) {
        this._notify(eventData, eventType);
    }
}

const serviceHotKeyName = "IHotKeyEventService";
Services.add(serviceHotKeyName, { serviceFactory: HotKeyEventService });